'use client';

import { RichEditorTemplate } from '@ametista-ai/editor/types';
import { useDebouncedCallback } from '@mantine/hooks';
import { RichEditor } from '@/components/RichEditor/RichEditor';

export function DocumentationField({
  content,
  onChange,
  templates,
  rightSection,
}: {
  content: string;
  onChange: (content: string) => void;
  templates?: RichEditorTemplate[];
  rightSection?: React.ReactNode;
}) {
  const debouncedOnChange = useDebouncedCallback(onChange, {
    delay: 500,
    flushOnUnmount: true,
  });

  return (
    <RichEditor
      initialContent={content}
      onChange={debouncedOnChange}
      templates={templates}
      rightSection={rightSection}
    />
  );
}
